import { useRef } from "react";

import { CollapsiblePanelContext } from "components/CollapsiblePanel/Context";
import Box, { BoxProps } from "ds/components/Box";
import TableBodyRow from "ds/components/Table/Row";
import useTypedContext from "hooks/useTypedContext";

import styles from "./styles.module.css";

type CollapsibleRowContentProps = {
  cellSpan?: number;
} & BoxProps;

const CollapsibleRowContent = ({ children, cellSpan, ...rest }: CollapsibleRowContentProps) => {
  const { isCollapsed, contentId } = useTypedContext(CollapsiblePanelContext);
  const ref = useRef<HTMLDivElement>(null);

  const contentHeight = ref.current?.clientHeight ?? 0;

  return (
    <TableBodyRow
      className={styles.collapsible}
      id={contentId}
      {...(isCollapsed ? { ["aria-hidden"]: true } : null)}
    >
      <td className={styles.collapsibleContent} colSpan={cellSpan} aria-colspan={cellSpan}>
        <div
          style={{
            maxHeight: isCollapsed ? 0 : `${contentHeight}px`,
          }}
          className={styles.collapsibleContent}
        >
          <Box ref={ref} fullWidth direction="column" {...rest}>
            {children}
          </Box>
        </div>
      </td>
    </TableBodyRow>
  );
};

export default CollapsibleRowContent;
